import axios from "axios";

const hyu = process.env.VUE_APP_HYU
// const modelsHeader = {
//     'Content-Type': 'application/json',
//     'AccessToken': process.env.VUE_APP_MODELSTOKEN,
// }

const state = () => ({
    versions: [],
    // hasVersions: false,
    lstEquipment: [],
});

const getters = {
    getModelVersions: state => (id, engine) => {
        let res = state.versions.filter(el => (el.modelID == id && el.idEngine == engine))

        res.sort((prev, curr) => {
            let a = prev.price
            let b = curr.price

            return parseFloat(a) > parseFloat(b) ? 1 : -1
        })

        return res
    },
    getModelEquips: state => (arr, bool) => {
        let versionEqui = state.lstEquipment.filter(el => arr.includes(el.id))
        let safety = [];
        let confort = [];
        let ext = [];
        let int = [];

        versionEqui.map(el => {
            let content = el.value
            if(bool) content = {id: el.id, name: el.value};

            if(el.idType == 32) ext.push(content)
            if(el.idType == 33) confort.push(content)
            if(el.idType == 34) int.push(content)
            if(el.idType == 35) safety.push(content)
        })

        let __arr = [
            { name: 'Conforto', specs: confort },
            { name: 'Exterior', specs: ext },
            { name: 'Interior', specs: int },
            { name: 'Segurança', specs: safety }
        ]
        let res = [ {  title: '', details: __arr} ]
        return bool ? __arr : res
    },
    hasVersions: state => id => {
        let res = state.versions.find(el => el.modelID == id)
        return res ? true : false
    },
    getResidualValue: state => id => {
        let res = state.versions.find(el => el.id == id)
        let val = res?.residualValue
        if(val) return val
        return 0
    },
    getVersionById: state => (id) => {
        let res = state.versions.find(el => el.id == id)
        return res
    }
};

const mutations = {
    SET_VERSIONS(state, payload){
        payload.forEach(version => {
            // let bool = state.versions.some(el => el.modelID == version.id)
            // if(!bool)
            state.versions.push(version)
        });
        state.hasVersions = true
    },
    SET_EQUIPMENT(state, payload){
        state.lstEquipment = payload
    },

};

const actions = {
    fetchVersions({ commit, getters }, id){
        if(getters.hasVersions(id)) return

        let url = hyu + process.env.VUE_APP_API_VERSIONS + id;

        // axios.get(url, { headers: modelsHeader })
        axios.get(url)
        .then( res => commit('SET_VERSIONS', res.data))
        .catch( err => console.log(err))
    },
    fetchEquipments({ commit }){
        // axios.get(hyu + process.env.VUE_APP_API_VERSIONS_EQIP, { headers: modelsHeader })
        axios.get(hyu + process.env.VUE_APP_API_VERSIONS_EQIP)
        .then( res => commit('SET_EQUIPMENT', res.data))
        .catch(err => console.log(err))
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
